const normalizeString = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

const appendSentence = (segments, value) => {
  const normalized = normalizeString(value).replace(/\s+/g, " ");
  if (!normalized) {
    return;
  }
  segments.push(normalized.endsWith(".") ? normalized : `${normalized}.`);
};

export const formatProviderTestStatus = (status) => ({
  unknown: "never run",
  ok: "ok",
  error: "error",
}[normalizeString(status)] || normalizeString(status) || "unknown");

export const buildProviderTestSuccessMessage = (providerKey, result) => {
  const model = normalizeString(result?.model);
  if (model) {
    return `Conexiunea pentru ${providerKey} a fost testată cu succes. Model folosit: ${model}.`;
  }
  return `Conexiunea pentru ${providerKey} a fost testată cu succes.`;
};

export const buildProviderTestErrorMessage = (error, providerKey) => {
  const responseData = error?.response?.data || {};
  const details = responseData.details || error?.details || {};
  const errorCode = normalizeString(responseData.error || error?.code);
  const segments = [];

  appendSentence(
    segments,
    responseData.message || error?.message || `Testul pentru ${providerKey} a eșuat`
  );

  const upstreamMessage = normalizeString(details.upstream_message || details.message);
  const mainMessage = normalizeString(responseData.message || error?.message);
  if (upstreamMessage && upstreamMessage !== mainMessage && !mainMessage.includes(upstreamMessage)) {
    appendSentence(segments, `Detaliu provider: ${upstreamMessage}`);
  }

  const meta = [];
  if (details.upstream_status || details.status) {
    meta.push(`HTTP ${details.upstream_status || details.status}`);
  }
  if (details.model) {
    meta.push(`model ${details.model}`);
  }
  if (details.upstream_code) {
    meta.push(`code ${details.upstream_code}`);
  } else if (details.upstream_status_text) {
    meta.push(`status ${details.upstream_status_text}`);
  }
  if (details.request_id) {
    meta.push(`request ${details.request_id}`);
  }
  if (meta.length) {
    const metaText = meta.join(", ");
    if (!mainMessage.includes(metaText)) {
      appendSentence(segments, `Context: ${metaText}`);
    }
  }

  if (details.hint) {
    const hintText = normalizeString(details.hint);
    if (!mainMessage.includes(hintText)) {
      appendSentence(segments, `Hint: ${hintText}`);
    }
  } else if (errorCode === "AI_CREDENTIAL_DECRYPT_FAILED") {
    appendSentence(
      segments,
      "Hint: Reintrodu API key-ul pentru acest provider; credentialul criptat vechi nu poate fi recuperat cu cheia master curentă"
    );
  }

  return segments.join(" ");
};

export const extractStoredProviderError = (provider) => normalizeString(provider?.last_test_error);

export const hasCredentialDecryptError = (provider) =>
  extractStoredProviderError(provider).toLowerCase().includes("decript");
